// extracted by mini-css-extract-plugin
export var addWidgetButton = "_10-6";
export var backButton = "_10-1";
export var legacyWidgetContainer = "_10-5";
export var pageContainer = "_10-2";
export var settingsContent = "_10-0";
export var widgetSubsectionItem = "_10-3";
export var widgetSubsectionItemContent = "_10-4";